import { BaseApiService } from '@/services/base-service';
import { BaseResponse } from '@/types';
import { Contacts, SendAppeal } from '../types';

interface ContactsList extends BaseResponse {
  data: {
    items: Contacts.Card[],
    widgets: Contacts.CardItems[],
  }
}

interface SendForm extends BaseResponse {
  data: {
    documents: SendAppeal
  };
}

export class ContactsService extends BaseApiService {
  private readonly base_path = 'contacts';

  async get_contacts(): Promise<ContactsList> {
    const { data } = await this.http_client.get<ContactsList>(this.base_path);

    return data;
  }

  async sent_appeal(payload: SendAppeal): Promise<SendForm> {
    const form_data = new FormData();

    Object.entries(payload).forEach(([
      key, value,
    ]) => {
      if (Array.isArray(value)) {
        value.forEach((file, index) => {
          form_data.append(`${key}[${index}]`, file);
        });
      } else {
        form_data.append(key, value as string | Blob);
      }
    });

    const { data } = await this.http_client.post<SendForm>(this.base_path, form_data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  }
}
